import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// Extend Day.js with the necessary plugins
dayjs.extend(utc)
dayjs.extend(timezone)

export const getLastUpdatedTime = (ist?: string) => {
  if (!ist) return ''

  // Parse the date in the IST timezone
  const date = dayjs(ist).tz('Asia/Kolkata')

  if (date.isValid()) {
    return `${date.format('MMMM D, YYYY')} at ${date.format('h:mm a')}`
  } else {
    return ''
  }
}

export const getLastUpdatedDate = (ist?: string) => {
  if (!ist) return ''

  // Parse the date in the IST timezone
  const date = dayjs(ist).tz('Asia/Kolkata')

  if (date.isValid()) {
    return date.format('MMMM D, YYYY')
  } else {
    return ''
  }
}
